import api from '../utils/api';

/**
 * Request a database backup. The API streams a .sql file.
 * Returns a promise that resolves when the download has been triggered; rejects on API error.
 */
export const downloadDatabaseBackup = async () => {
  const response = await api.get('/data/backup/database', {
    responseType: 'blob',
  });
  const blob = response.data;
  const contentType = response.headers['content-type'] || '';
  if (contentType.includes('application/json')) {
    const text = await blob.text();
    let errMsg = 'Backup failed';
    try {
      const json = JSON.parse(text);
      errMsg = json.message || errMsg;
    } catch (_) {}
    throw new Error(errMsg);
  }
  const disposition = response.headers['content-disposition'] || '';
  const match = disposition.match(/filename="?([^"]+)"?/);
  const filename = match ? match[1] : `backup-${new Date().toISOString().slice(0, 10)}.sql`;
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
};
